import React, { useState, useEffect, useMemo } from 'react'
import './nav.css'
import useAuth from '../../hooks/useAuth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import axios from '../../api/axios';
import useIsMobile from '../../hooks/useIsMobile';
import NavItems from './NavItems';
import NavItemsMobile from './NavItemsMobile';
import { Link } from 'react-router-dom';
import { defaultLanguage } from "../../constants";

const LANG_URL = '/contact';
const WEBSITE_URL = '/websiteAuth/calendar';
const DASH_URL = '/dashboard';
const PUBLIC_PROPERTIES_URL = '/properties/public';

export default function Nav() {

  //hooks
  const art = defaultLanguage;
  const title = "accomodationForm";
  const { i18n } = useTranslation();
  const { auth, username } = useAuth();
  const [languages, setLanguages] = useState([]);
  const isMobile = useIsMobile();
  const [calendar, setCalendar] = useState([]);
  const [showSpecialOffers, setShowSpecialOffers] = useState(true);
  const [showBlogs, setShowBlogs] = useState(true);
  const [hasSubProperties, setHasSubProperties] = useState(false);

  const tenantKey = useMemo(() => {
    return String(username || "").trim().toLowerCase();
  }, [username]);

  const isSubTenant = useMemo(() => {
    const u = String(username || "").trim().toLowerCase();
    return u.includes(".");
  }, [username]);

  const showBookNow = useMemo(() => {
    const hasCalendar = calendar && calendar !== "no";
    if (!hasCalendar) return false;
    if (isSubTenant) return true;
    return !hasSubProperties;
  }, [calendar, hasSubProperties, isSubTenant]);

  useEffect(() => {
    const getContent = async () => {
      await axios.get(`${WEBSITE_URL}`, {
        params: { username: tenantKey },
      }).then((res) => {
        setCalendar(res?.data?.calendar);
      }).catch((err) => {
        console.log(err);
      });

      if (!isSubTenant) {
        const host = String(window?.location?.hostname || "").trim().toLowerCase();
        const mainDomain = (host && host !== "localhost" && host !== "127.0.0.1")
          ? host
          : tenantKey;
        axios.get(`${PUBLIC_PROPERTIES_URL}`, { params: { mainDomain } })
          .then((res) => {
            const list = Array.isArray(res?.data?.properties) ? res.data.properties : [];
            setHasSubProperties(list.length > 0);
          })

          .catch(() => {
            setHasSubProperties(false);
          });
      } else {
        setHasSubProperties(false);
      }

      axios.get(`${LANG_URL}`, {
        params: { username: tenantKey, art: "nl", title: "contact" },
      }).then((res) => {
        setLanguages(res?.data?.entry?.languages?.split(","));
      }).catch((err) => {
        console.log(err);
      });
      axios.get(`${DASH_URL}`, {
        params: { username: tenantKey, art, title },
      }).then((res) => {
        setShowSpecialOffers(res?.data?.entry?.showSpecialOffers);
        setShowBlogs(res?.data?.entry?.showBlogs);
      }).catch((err) => {
        console.log(err);
      });
    };
    getContent();
  }, [tenantKey, art, isSubTenant]);

  return (
    <div>
      <ul>
        <div className="navbar">
          {isMobile ? (
            <NavItemsMobile isAdmin={auth.role} calendarUrl={calendar} showBookNow={showBookNow} />
          ) : (
            <NavItems isAdmin={auth.role} calendarUrl={calendar} showSpecialOffers={showSpecialOffers} showBlogs={showBlogs} />
          )}
          <li className="dropdown">
            <div className="nav-link">
              {!isMobile && (
                <div style={{ display: "inline-flex" }}>
                  {i18n.language}
                  <span className="hspace"></span>
                </div>
              )}
              <FontAwesomeIcon
                icon={faGlobe}
                className="absolute top-1/2 right-0 transform -translate-y-1/2 pointer-events-none text-black"
              />
            </div>
            {/* change prefix from list */}
            {languages !== null && (
              <div className="dropdown-content">
                {languages?.map((code) => (
                  <button
                    key={code}
                    value={code}
                    className="drop"
                    onClick={(e) => {
                      i18n.changeLanguage(e.target.value);
                    }}
                  >
                    {code}
                  </button>
                ))}
              </div>
            )}
          </li>

          {!isMobile && showBookNow && (
            <Link className="book-now-btn book-now-btn-margin" to={calendar}>
              Book Now
            </Link>
          )}
        </div>
      </ul>
    </div>
  );
}